import type { DutyRequestWithRelations } from "@dutyon/apis";
import { Button, DutyRequestBadge, getRelativeOrFormattedDate, Table, Text } from "@dutyon/ui-kit";
import { useNavigate } from "react-router-dom";
import { formatDutyRequestDateKey } from "../../services/dutyRequestDate";

interface DutyRequestTableProps {
  list: DutyRequestWithRelations[];
}

export function DutyRequestTable({ list }: DutyRequestTableProps) {
  const navigate = useNavigate();

  // 특정 요청의 상세 페이지로 이동하는 핸들러
  const handleRowClick = (id: string) => {
    navigate(`/duty-requests/${id}`);
  };

  return (
    <Table.ScrollContainer minWidth={800}>
      <Table highlightOnHover verticalSpacing="md" withTableBorder withColumnBorders={false}>
        <Table.Thead>
          <Table.Tr>
            <Table.Th style={{ width: "120px" }}>신청자</Table.Th>
            <Table.Th>병원 / 부서</Table.Th>
            <Table.Th style={{ width: "240px" }}>요청 근무 기간</Table.Th>
            <Table.Th style={{ width: "110px", textAlign: "center" }}>대상 인원수</Table.Th>
            <Table.Th style={{ width: "140px" }}>요청일</Table.Th>
            <Table.Th style={{ width: "110px", textAlign: "center" }}>처리 상태</Table.Th>
            <Table.Th style={{ width: "90px", textAlign: "center" }}>상세</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {list.map((item) => (
            <Table.Tr
              key={item.id}
              onClick={() => handleRowClick(item.id)}
              style={{ cursor: "pointer" }}
            >
              <Table.Td>
                <Text fw={600} size="sm">
                  {item.nurse?.user?.name || "-"}
                </Text>
              </Table.Td>
              <Table.Td>
                <Text size="sm">{item.team?.company?.name || "-"}</Text>
                <Text size="xs" c="dimmed">
                  {item.team?.name || "-"}
                </Text>
              </Table.Td>
              <Table.Td>
                <Text size="sm" fw={500}>
                  {formatDutyRequestDateKey(item.startDate)} ~{" "}
                  {formatDutyRequestDateKey(item.endDate)}
                </Text>
              </Table.Td>
              <Table.Td style={{ textAlign: "center" }}>
                <Text size="sm" fw={600} c="blue">
                  {item.targetNurseIds.length}명
                </Text>
              </Table.Td>
              <Table.Td>
                <Text size="xs" c="dimmed">
                  {getRelativeOrFormattedDate(item.createdAt)}
                </Text>
              </Table.Td>
              <Table.Td style={{ textAlign: "center" }}>
                <DutyRequestBadge status={item.status} />
              </Table.Td>
              <Table.Td style={{ textAlign: "center" }}>
                <Button
                  size="xs"
                  variant="subtle"
                  onClick={(e) => {
                    e.stopPropagation(); // 행 클릭 이벤트 버블링 방지
                    handleRowClick(item.id);
                  }}
                >
                  상세
                </Button>
              </Table.Td>
            </Table.Tr>
          ))}
        </Table.Tbody>
      </Table>
    </Table.ScrollContainer>
  );
}
